import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "app-driveb-master-view",
    templateUrl: "./master-view.component.html",
    styleUrls: ["./master-view.component.scss"],
    standalone: false
})
export class MasterViewComponent {
  @HostBinding("class.container-content-padded")
  @Input()
  public isPadded = true;
}
